export default __webpack_public_path__ + "static/media/sojosWestLogo.0f73e32f.png";